var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isList && _vm.status)?_c('evaluate-score-analysis',{attrs:{"scope":_vm.scope,"scopeId":_vm.scopeId}}):_c('wart')}
var staticRenderFns = []

export { render, staticRenderFns }